<template>
  <div>
    <TopBarTitleComponent :title="'Movimientos: ' + name" :showBackIcon="true">
    </TopBarTitleComponent>

    <b-container fluid class="pb-4 px-lg-4">
      <template v-if="apiResponse.success">
        <template v-if="expandedProducts.length">
          <!-- Summary card -->
          <div class="mvd-summary">
            <div class="mvd-summary-item">
              <span class="mvd-summary-label">Producto</span>
              <span class="mvd-summary-value">{{ name }}</span>
            </div>
            <div class="mvd-summary-item">
              <span class="mvd-summary-label">Total movimientos</span>
              <span class="mvd-summary-value">{{ stocks.length }}</span>
            </div>
          </div>

          <!-- Table -->
          <div class="dir-table">
            <div class="dir-table-header mvd-table-header">
              <span>#</span>
              <span>Descripción</span>
              <span>Cantidad</span>
              <span>Fecha</span>
            </div>
            <div
              v-for="(item, idx) in getTableData"
              :key="idx"
              class="dir-table-row mvd-table-row"
            >
              <span class="mvd-idx">{{
                idx + 1 + (currentPage - 1) * pageSize
              }}</span>
              <span class="mvd-desc">{{ item.description }}</span>
              <span
                :class="[
                  'mvd-qty',
                  item.quantity > 0
                    ? 'qty-in'
                    : item.quantity < 0
                    ? 'qty-out'
                    : ''
                ]"
              >
                {{ item.quantity > 0 ? "+" : "" }}{{ item.quantity }}
              </span>
              <span class="mvd-date">{{ formatDate(item) }}</span>
            </div>
            <div v-if="!getTableData.length" class="dir-table-empty">
              Sin movimientos registrados
            </div>
          </div>

          <!-- Simple pagination -->
          <div v-if="totalItems > pageSize" class="mvd-pagination">
            <el-button
              size="small"
              :disabled="currentPage <= 1"
              @click="currentPage--"
            >
              <i class="el-icon-arrow-left"></i> Anterior
            </el-button>
            <span class="mvd-page-info">
              {{ currentPage }} de {{ Math.ceil(totalItems / pageSize) }}
            </span>
            <el-button
              size="small"
              :disabled="currentPage >= Math.ceil(totalItems / pageSize)"
              @click="currentPage++"
            >
              Siguiente <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </template>
        <EmptyPage
          icon="el-icon-refresh-left"
          text="No hay movimientos registrados para este producto."
          v-else
        />
      </template>
      <LoadingSkeletonTable v-else />
    </b-container>

    <WrapperCatalogTourComponent />
  </div>
</template>

<script>
import TopBarTitleComponent from "../../../components/TopBarTitle";
import LoadingSkeletonTable from "@/components/Animations/Loading/SkeletonTable";
import catalogueService from "../../services/catalogueService";
import WrapperCatalogTourComponent from "../WrapperTour";
import EmptyPage from "../../../components/EmptyPage";
import tradeService from "../../../profile/services/tradeService";
export default {
  name: "MovementDetailListComponent",
  data: () => ({
    filters: {
      search: null,
      page: 1
    },
    pagination: null,
    apiResponse: {
      success: false
    },
    orderByQuery: null,
    products: [],
    modalStatus: false,
    modalTransfers: false,
    modalMovements: false,
    stocks: [],
    form: {
      user_business_product_id: null,
      user_business_product_name: null,
      quantity: null,
      establishment_id: null,
      reason_transfer: ""
    },
    formTransfer: {
      user_business_product_id: null,
      user_business_product_name: null,
      user_business_product_quantity: null,
      quantity: null,
      establishment_origin_id: null,
      establishment_destiny_id: null
    },
    stablishments: [],
    type: "input",
    movementsData: [],
    currentPage: 1,
    pageSize: 5,
    name: ""
  }),
  computed: {
    expandedProducts() {
      return this.stocks;
    },
    getTableData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.stocks.slice(start, end);
    },
    totalItems() {
      return this.stocks.length;
    }
  },
  methods: {
    async handleGetProductId(productId) {
      try {
        let response = await catalogueService
          .getProductId(productId)
          .finally(() => {
            this.toggleApiResponse("success", true);
          });

        if (response.data.product) {
          this.name = response.data.product.name || "";
          this.stocks = response.data.product.stocks.flatMap(
            stock => stock.details
          );
        }
      } catch (error) {
        return false;
      }
    },
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },
    onSelectOrderBy({ orderBy }) {
      this.orderByQuery = orderBy;
    },
    onSelectProduct({ product }) {
      this.form.user_business_product_id = product.id;
      this.form.user_business_product_name = product.name;
    },
    async getStablishments() {
      try {
        const response = await tradeService.getStablishments();
        const establishmentsData = response.data?.data || [];
        this.stablishments = establishmentsData;
      } catch (error) {
        return false;
      }
    },
    indexMethod(index) {
      return index + 1;
    },
    formatDate(row) {
      return new Date(row.created_at).toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    },
    // Método para manejar el cambio de tamaño de página
    handleSizeChange(size) {
      this.pageSize = size;
    },
    // Método para manejar el cambio de página actual
    handleCurrentChange(page) {
      this.currentPage = page;
    }
  },
  components: {
    TopBarTitleComponent,
    LoadingSkeletonTable,
    WrapperCatalogTourComponent,
    EmptyPage
  },
  mounted() {
    const { id: productId } = this.$route.params;
    if (productId) this.handleGetProductId(productId);
  }
};
</script>

<style scoped lang="scss">
$primary: #31355c;
$border: #e4eaf6;
$bg: #f7f8f9;

.mvd-summary {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
}
.mvd-summary-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mvd-summary-label {
  font-size: 12px;
  color: #909399;
  font-weight: 600;
}
.mvd-summary-value {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
}

.mvd-table-header,
.mvd-table-row {
  grid-template-columns: 50px 1fr 100px 180px !important;
}
.mvd-idx {
  font-size: 13px;
  color: #909399;
  text-align: center;
}
.mvd-desc {
  font-weight: 500;
  color: $primary;
}
.mvd-qty {
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  &.qty-in {
    color: #1d9e75;
  }
  &.qty-out {
    color: #e24b4a;
  }
}
.mvd-date {
  font-size: 13px;
  color: #606266;
}

.mvd-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 0;
}
.mvd-page-info {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}
</style>
